import { postAttributes } from "~/types";
/**
 * It takes a post and returns the image path to that post
 * @param {Post} post - Post
 * @returns The path to the image.
 */
export function getPostImage(post: postAttributes) {
  switch (post.type) {
    case "Press Release":
      return post.headline?.image?.data?.attributes || undefined;
    case "Article":
    case "Blog":
      return post.template[0].headline?.image?.data?.attributes || undefined;
    case "Newsletter":
    case "Presentation":
    case "Factsheet":
      return (
        post.template[0]?.["headline-main"].image.data.attributes || undefined
      );
    default:
      return post?.headlineMain?.image?.data?.attributes || undefined;
  }
}
